import SetupForm from './SetupForm';

const CreditCards = {
    SetupForm: SetupForm
};

export default CreditCards;